import mimeDb from 'mime-db/db.json';

export default {
    ...mimeDb,
    'application/acad': {
        "source": "iana",
        "extensions": ["dwg"]
    },
    'image/x-dwg': {
        "source": "iana",
        "extensions": ["dwg"]
    },
    "application/vnd.dwg": {
        "source": "iana",
        "extensions": ["dwg"]
    },
    "application/dwg": {
        "source": "common",
        "extensions": ["dwg"]
    },
    "application/x-dwg": {
        "source": "common",
        "extensions": ["dwg"]
    },
    "drawing/dwg": {
        "source": "other",
        "extensions": ["dwg"]
    },
    "application/x-zip-compressed": {
        "source": "common",
        "extensions": ["zip"]
    }
}
